module.exports = [{
      plugin: require('/Users/rbourland/Documents/git/gatsby/ux-method-flow/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
